module.exports = __webpack_public_path__ + "media/banner-risk.9c4f8a07.mp4";